import { render, staticRenderFns } from "./TvDetail.vue?vue&type=template&id=75123b72&scoped=true&"
import script from "./TvDetail.vue?vue&type=script&lang=js&"
export * from "./TvDetail.vue?vue&type=script&lang=js&"
import style0 from "./TvDetail.vue?vue&type=style&index=0&id=75123b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75123b72",
  null
  
)

export default component.exports